export const joinCommunityErrorsSelector = state => state.joinCommunity.get('joinCommunityErrors');
